/**
 * ============================================================
 * 繁體中文 (Traditional Chinese)
 * ============================================================
 *
 * Translators:
 *
 * Koala Yeung <koalay@gmail.com>
 */

/**
 * 常用字詞的譯法
 * --------------
 *
 * - Save︰保存進度（動詞）；存檔（名詞）
 * - Load︰載入進度
 * - Slot︰位置
 * - Screen︰介面
 * - Auto︰自動播放
 * - Skip︰快轉
 */

export default {
	'AdvanceHelp': '點按滑鼠左鍵、輕觸螢幕、或按空白鍵繼續遊戲',
	'AllowPlayback': '點擊以批准播放聲效',
	'Audio': '聲效',
	'AutoPlay': '自動',
	'AutoPlayButton': '進入自動播放模式',
	'AutoPlaySpeed': '自動播放速度',

	'Back': '返回',
	'BackButton': '返回',

	'Cancel': '取消',
	'Close': '關閉',
	'Confirm': '你確定要離開了嗎？',
	'Credits': '製作及嗚謝',

	'Delete': '刪除',
	'DialogLogButton': '顯示對話紀錄',

	'FullScreen': '全螢幕',

	'Gallery': '圖庫',

	'Help': '幫助',
	'Hide': '隱藏',
	'HideButton': '隱藏對話框',

	'iOSAudioWarning': '在 iOS 上無法支援聲效設定',

	'KeyboardShortcuts': '鍵盤快捷鍵',

	'Language': '語言',
	'Load': '載入進度',
	'LoadAutoSaveSlots': '自動保存進度',
	'LoadButton': '打開載入進度的界面',
	'Loading': '載入中',
	'LoadingMessage': '媒體加載中，請稍候',
	'LoadSlots': '遊戲存檔',
	'LocalStorageWarning': '瀏覽器不支援 Local Storage 功能',
	'Log': '紀錄',

	'Music': '音樂音量',

	'NewContent': '有新的遊戲內容上線，請重新載入本頁，以取得最新版本',
	'NoSavedGames': '沒有已保存的進度',
	'NoAutoSavedGames': '沒有自動保存的進度',
	'NoDialogsAvailable': '沒有對話。若場景有對話，將會在這裏顯示。',

	'OK': 'OK',
	'OrientationWarning': '請旋轉你的裝置以進行遊戲',
	'Overwrite': '覆蓋存檔',

	'QuickButtons': '快速選單鍵',
	'QuickMenu': '快速選單',
	'Quit': '離開',
	'QuitButton': '離開遊戲',

	'Resolution': '解像度',

	'Save': '保存進度',
	'SaveButton': '開啟存檔介面',
	'SaveInSlot': '在這位置保存遊戲',
	'SelectYourLanguage': '選擇語言',
	'Settings': '設定',
	'SettingsButton': '開啟設定介面',
	'Show': '顯示',
	'Skip': '快轉',
	'SkipButton': '進入快轉模式',
	'SlotDeletion': '你是否確定要刪除這個位置的存檔？',
	'SlotOverwrite': '你是否確定要覆蓋這個位置的存檔？',
	'Sound': '聲音音量',
	'Start': '開始',
	'Stop': '停止',

	'TextSpeed': '文字速度',

	'Video': '影片音量',
	'Voice': '語音音量',

	'Windowed': '視窗'
};